import React from 'react'
import {
  Box,
  BoxProps,
  Image,
  Text,
  Flex,
  HStack,
  Spacer,
  Link,
} from '@chakra-ui/react'

import { ITeamMember } from '@/types/teamMember.interface'
import { getStrapiMedia } from '@/utils/getStrapiMedia'
import { XIcon } from '../icons/XIcon'
import { LinkedinIcon } from '@/components/icons/LinkedinIcon'

interface IProps extends BoxProps {
  data: ITeamMember
}

export function EmployeeCard({ data, ...rest }: IProps) {
  const { photo, name, twitter, linkedin, position } = data
  return (
    <Box {...rest}>
      {photo ? (
        <Image
          src={getStrapiMedia(photo.url)}
          alt={name}
          w={'full'}
          rounded={'2xl'}
          mb={3.5}
        />
      ) : null}
      <Flex direction={'row'} mb={1} alignItems={'baseline'}>
        <Text fontSize={'lg'} fontWeight={600}>
          {name}
        </Text>
        <Spacer />
        <HStack ml={2}>
          {twitter && <IconLink type={'twitter'} url={twitter} />}
          {linkedin && <IconLink type={'linkedin'} url={linkedin} />}
        </HStack>
      </Flex>
      <Text
        textTransform={'uppercase'}
        color={'brand.600'}
        fontSize={10}
        fontWeight={600}
      >
        {position}
      </Text>
    </Box>
  )
}

type IconLinkProps = {
  url: string
  type: 'twitter' | 'linkedin'
}

function IconLink({ url, type = 'twitter' }: IconLinkProps) {
  const renderIcon = (type: string) => {
    if (type === 'twitter') {
      return <XIcon />
    }

    if (type === 'linkedin') {
      return <LinkedinIcon />
    }
  }
  return (
    <Link
      isExternal
      href={url}
      color={'gray.400'}
      _hover={{ color: 'brand.600' }}
    >
      {renderIcon(type)}
    </Link>
  )
}
